import styled from '@emotion/styled';

import IconNext from '@/assets/icons/icon_next_gray.svg';
import { PC_HEADER_HEIGHT } from '@/layouts/DmmNav/style';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

import { PC_CROSS_BANNER_HEIGHT, PC_NAV_HEIGHT } from '../style';

function calcOverlay(hasNaviCrossBanner: boolean) {
  if (hasNaviCrossBanner) {
    return `calc(${PC_HEADER_HEIGHT}px + ${PC_NAV_HEIGHT}px + ${PC_CROSS_BANNER_HEIGHT}px)`;
  }
  return `calc(${PC_HEADER_HEIGHT}px + ${PC_NAV_HEIGHT}px)`;
}

export const Overlay = styled.div<{
  isActive: boolean;
  hasNaviCrossBanner: boolean;
  windowHeight: number;
}>(props =>
  mq({
    position: 'absolute',
    top: [0, 0, 0, calcOverlay(props.hasNaviCrossBanner)],
    left: 0,
    overflowY: 'auto',
    width: '100%',
    height: 'var(--vh)',
    maxHeight: ['var(--vh)', 'var(--vh)', 'var(--vh)', 'unset'],
    opacity: props.isActive ? '1' : 0,
    visibility: props.isActive ? 'visible' : 'hidden',
    backgroundColor: defaultTheme.background.overlay,
    zIndex: '1090', // 投票パネルより上にする
    transition: 'opacity .3s ease-in-out, visibility .2s ease-in-out',
  }),
);

export const LinkList = styled.ul<{
  isActive: boolean;
}>(props =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    right: props.isActive ? 0 : [-262, -262, -296],
    width: ['262px', '262px', '296px'],
    minHeight: '100%',
    padding: `0 ${defaultTheme.spacing.xxl}`,
    backgroundColor: defaultTheme.background.lightGray,
    transition: 'right .3s ease-in-out, visibility .2s ease-in-out',
  }),
);

export const LinkItem = styled.li(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    ...hoverOpacity,
    '&:after': {
      content: '""',
      width: '8.21px',
      height: '14px',
      backgroundImage: `url(${IconNext})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    },
    a: {
      display: 'block',
      width: '100%',
      height: '100%',
      fontSize: defaultTheme.font.size.s,
      padding: `${defaultTheme.spacing.xxl} 0`,
    },
  }),
);
